import React from 'react';

const Account = ({ ...props }) => <h2>Account Settings</h2>;

export default Account;
